import ScalarSidebarGroupToggleSpacer_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarGroupToggleSpacer.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarSidebar/ScalarSidebarGroupToggleSpacer.vue
var ScalarSidebarGroupToggleSpacer_default = ScalarSidebarGroupToggleSpacer_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarGroupToggleSpacer_default as default };

//# sourceMappingURL=ScalarSidebarGroupToggleSpacer.vue.js.map